import { useLang } from "@/i18n";

export default function Marquee() {
  const { c } = useLang();
  const items = [...c.marquee, ...c.marquee];
  return (
    <section data-testid="editorial-marquee" aria-hidden="true" className="overflow-hidden border-y border-white/10 bg-obsidian py-8">
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((item, i) => (
          <span key={i} className="flex items-center">
            <span className="px-10 font-serif text-2xl italic text-gold/60 sm:text-3xl">{item}</span>
            <span className="h-1.5 w-1.5 rotate-45 bg-gold/40" />
          </span>
        ))}
      </div>
    </section>
  );
}
